import React, { useState, useEffect, useContext } from "react";

import { PopUpContext } from "../../contexts/popUpContext";

const ToastMessage = () => {
  const [state, toggleState] = useState(false);
  const {
    togglePopUp,
    popUp: { message, type },
  } = useContext(PopUpContext);

  useEffect(() => {
    toggleState(true);

    setTimeout(() => {
      toggleState(false);
    }, 5000);
  }, []);

  return (
    <div className="toast-pop-up">
      <div className={`toast ${state ? "open" : ""} ${type ? type : ""}`}>
        <p>{message ? message : "اطلاعات ثبت گردید!"}</p>
      </div>
    </div>
  );
};

export default ToastMessage;
